import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { PRODUCTS } from "@/data/site";
import { SectionHeader } from "@/components/SectionHeader";
import { Stagger, Item } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const SPANS = [
  "md:col-span-7 md:row-span-2",
  "md:col-span-5",
  "md:col-span-5",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
];

const Tile = ({ p, span, s, viewSpecs, small }) => (
  <Item className={`group relative min-h-[260px] overflow-hidden rounded-3xl bg-[var(--ink)] ${span}`}>
    <Link to={`/services#${p.id}`} className="img-zoom block h-full" data-testid={`product-tile-${p.id}`}>
      <img src={p.img} alt={s.name} className="absolute inset-0 h-full w-full object-cover opacity-95" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/15 to-transparent" />
      <span
        className="absolute left-5 top-5 rounded-full px-3 py-1.5 font-mono-label text-[10px] text-white"
        style={{ background: p.color }}
      >
        {s.tag}
      </span>
      <div className="absolute inset-x-0 bottom-0 p-6 text-white">
        <h3 className={`font-display font-bold leading-tight ${small ? "text-xl md:text-[1.35rem]" : "text-2xl md:text-3xl"}`}>{s.name}</h3>
        <p className="mt-2 hidden max-w-md text-sm leading-relaxed text-white/75 opacity-0 transition-opacity duration-500 group-hover:opacity-100 line-clamp-2 lg:block">
          {s.blurb}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-[var(--lime)]">
          {viewSpecs} <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  </Item>
);

export const ProductsBento = () => {
  const { t } = useLang();
  const s = t.products;
  return (
  <section className="py-24 lg:py-32" data-testid="products-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeader eyebrow={s.eyebrow} title={s.title} text={s.text} />
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
          <Link to="/services" className="btn-ghost" data-testid="products-view-all">
            {s.viewAll} <ArrowUpRight size={16} />
          </Link>
        </motion.div>
      </div>

      <Stagger className="mt-14 grid gap-4 md:auto-rows-[240px] md:grid-cols-12" stagger={0.1}>
        {PRODUCTS.map((p, i) => (
          <Tile key={p.id} p={p} span={SPANS[i]} s={s.items[p.id]} viewSpecs={s.viewSpecs} small={i >= 3} />
        ))}
      </Stagger>
    </div>
  </section>
  );
};
